'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Field = function Field(_ref) {
    var children = _ref.children,
        width = _ref.width,
        className = _ref.className,
        label = _ref.label;

    var utilClasses = width && width.split(' ').map(function (w) {
        return 'u-' + w;
    });
    var fieldClassNames = (0, _classnames2.default)(['luna-form__field', utilClasses, className]);
    return _react2.default.createElement("div", { className: fieldClassNames }, label && _react2.default.createElement(_.Label, null, label), children);
};
Field.propTypes = {
    width: _propTypes2.default.string,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
    label: _propTypes2.default.node
};
exports.default = Field;
//# sourceMappingURL=Field.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Field/Field.js